import { formatINR } from "@/lib/format";

/** Balance Sheet: Assets vs Liabilities → Net Worth (as of today). */
export function BalanceSheet({ bs }) {
  if (!bs) return null;
  const positive = bs.net_worth >= 0;
  return (
    <section className="border border-[#D8D4C7] bg-white" data-testid="balance-sheet">
      <div className="border-b border-[#1A1F16] px-6 py-4">
        <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#6C7565]">Statement · as of today</div>
        <h3 className="font-serif text-3xl tracking-tight">Balance Sheet.</h3>
      </div>

      <Side title="Assets" rows={bs.assets} total={bs.assets_total} accent="#2E6F40" empty="No accounts yet — add one on the Accounts page." testid="bs-assets" />
      <Side title="Liabilities" rows={bs.liabilities} total={bs.liabilities_total} accent="#D94F3D" empty="No unpaid bills — you're all clear." testid="bs-liabilities" />

      <div className="flex items-center justify-between px-6 py-5 bg-[#1A1F16] text-[#F7F5F0]">
        <span className="font-mono text-[11px] tracking-[0.25em] uppercase">Net Worth</span>
        <span className={`font-serif text-3xl num ${positive ? "text-[#8FD19E]" : "text-[#F0A79C]"}`} data-testid="bs-net-worth">
          {formatINR(bs.net_worth)}
        </span>
      </div>
    </section>
  );
}

function Side({ title, rows, total, accent, empty, testid }) {
  return (
    <div className="px-6 py-5 border-b border-[#EAE7DD]" data-testid={testid}>
      <div className="flex items-center justify-between mb-3">
        <span className="font-mono text-[11px] tracking-[0.25em] uppercase" style={{ color: accent }}>{title}</span>
        <span className="font-serif text-xl num">{formatINR(total)}</span>
      </div>
      {rows.length === 0 ? (
        <p className="text-sm text-[#6C7565] italic">{empty}</p>
      ) : (
        <div className="space-y-0.5">
          {rows.map((r, i) => (
            <div key={`${r.label}-${i}`} className="flex items-center justify-between py-0.5 text-sm text-[#4A5142]">
              <span>{r.label}</span>
              <span className="num text-[#6C7565]">{formatINR(r.amount)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
